module.exports = __webpack_public_path__ + "img/empty-statistics-image.5fa83de4.svg";